import React from "react";

/**
 * Homepage global sponsor chip — reuses the exact visual language of the
 * gallery sponsor pastilles (same light/dark background, same rounded shape).
 * Sizes are matched to the gallery `partner` chips (h-12, max-w-[200px]).
 */
const LOGO_BG = { light: "bg-white", dark: "bg-slate-900" };

export const SponsorChip = ({ sponsor, testid }) => {
  const bgKey = sponsor.logo_background === "dark" ? "dark" : "light";
  const chipCls = `inline-flex items-center justify-center rounded-lg h-12 min-w-[120px] ${LOGO_BG[bgKey]} px-3 py-1 border border-white/10 shadow-inner`;
  const content = sponsor.logo_url ? (
    <img
      src={sponsor.logo_url}
      alt={sponsor.name}
      className="h-full w-auto max-w-[200px] object-contain"
      loading="lazy"
      decoding="async"
      width="120"
      height="48"
      onError={(e) => {
        e.currentTarget.replaceWith(document.createTextNode(sponsor.name));
      }}
    />
  ) : (
    <span className={`text-sm font-medium ${bgKey === "dark" ? "text-white" : "text-slate-900"}`}>
      {sponsor.name}
    </span>
  );
  return sponsor.website_url ? (
    <a
      href={sponsor.website_url}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testid}
      title={sponsor.name}
      className={`${chipCls} hover:brightness-110 transition-all`}
    >
      {content}
    </a>
  ) : (
    <span data-testid={testid} className={chipCls}>
      {content}
    </span>
  );
};

export default SponsorChip;
